// tslint:disable
export enum TCSRelationshipType {
    /**
     * @description Parent
     */
    Parent = 0,
    /**
     * @description Legal Guardian
     */
    LegalGuardian = 1,
    /**
     * @description Other
     */
    Other = 2,
}
(TCSRelationshipType as any)['PARENT'] = 0;
(TCSRelationshipType as any)['LEGALGUARDIAN'] = 1;
(TCSRelationshipType as any)['OTHER'] = 2;
